import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Загрузка...", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Ошибка загрузки балансов", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.b('loading'))
        }, _hoisted_2, 2))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(_ctx.b('error'))
          }, _hoisted_4, 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(_ctx.b('table'))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('table-header'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedColumns, (column) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(_ctx.b('column')),
                  key: column.id
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.b('column-label'))
                  }, _toDisplayString(_ctx.$t(column.label)), 3),
                  _createElementVNode("button", {
                    class: _normalizeClass(_ctx.b('column-sort'))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.b('column-icon')),
                      innerHTML: _ctx.displayedSvg.sort
                    }, null, 10, _hoisted_5)
                  ], 2)
                ], 2))
              }), 128))
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallets, (wallet) => {
              return (_openBlock(), _createElementBlock("div", {
                key: wallet.id,
                class: _normalizeClass(_ctx.b('table-row', { frozen: wallet.frozen }))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('table-row-cell'))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.b('table-row-currency'))
                  }, [
                    (wallet.type === 'fiat')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([
        _ctx.b('table-row-icon'),
        'fi',
        `fi-${wallet.country}`,
      ])
                        }, null, 2))
                      : (wallet.type === 'crypto' && wallet.name)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: _normalizeClass(_ctx.b('table-row-icon', { crypto: true })),
                            src: require(`@/assets/images/crypto/${wallet.name.toLowerCase()}.svg`),
                            alt: wallet.name
                          }, null, 10, _hoisted_6))
                        : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.b('table-row-name'))
                    }, _toDisplayString(wallet.name), 3),
                    (wallet.frozen)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(_ctx.b('table-row-frozen'))
                        }, "Frozen", 2))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.b('table-row-tag'))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.b('table-row-type', {
              bank: (wallet.type as string) === 'fiat',
              crypto: (wallet.type as string) === 'crypto',
            }))
                    }, _toDisplayString((wallet.type as string) === "fiat" ? "Bank Account" : "Crypto Account"), 3)
                  ], 2)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('table-row-cell'))
                }, _toDisplayString(_ctx.formatAmount(wallet.amount, wallet.precision)), 3)
              ], 2))
            }), 128))
          ], 2))
  ], 2))
}